import React from 'react';
import { LinkContent } from '../partials';
import { LinkProps } from '../Link';

const LinkDefault = ({ ...props }: LinkProps) => {
  return <LinkContent {...props} />;
};

export default LinkDefault;
